import {
  FormatterISODateTime,
  FormatterDateTime,
  Format
} from './DateFormatter'

import {
  FormatterName
} from './FormatterName'

import {
  composite
} from '../../Utils/Composite'

import {
  FormatterCurrency
} from './FormatterCurrency'

export default {
  install(Vue) {

    Vue.filter('FormatterReal', value => FormatterCurrency.real(value))

    Vue.filter('ISODateToDate', (value) => FormatterISODateTime.toDate(value))
    Vue.filter('ISOTimeToTime', (value) => FormatterISODateTime.toTime(value))
    Vue.filter('ISODateTimeToDateTime', (value) => FormatterISODateTime.toDateTime(value))

    Vue.filter('dateFormat', (value) => FormatterDateTime.toDate(value))

    Vue.filter('dateISOFormat', (value) => Format(
        composite(value)(
          FormatterISODateTime.toDate,
          FormatterDateTime.toDate))
      .to('DD/MM/YYYY'))

      Vue.filter('dateTimeISOFormat', (value) => {
        if(value){
          return Format(composite(value)(FormatterISODateTime.toDateTime)).to('DD/MM/YYYY HH:mm:ss')
        }
        return ""
      }),

    Vue.filter('timeFormat', (value) => composite(value)(
      FormatterISODateTime.toDateTime,
      FormatterDateTime.toTime
    ))

    Vue.filter('firstAndLastName', value => FormatterName.firstAndLast(value))

  }
}



// WEBPACK FOOTER //
// ./src/plugins/filters/index.js